import $foreign from "./foreign.cjs";
var _debugger = $foreign._debugger;
var _spy = $foreign._spy;
var _trace = $foreign._trace;
export { _debugger, _spy, _trace };
